import { useCallback, useMemo } from 'react';
import { usePageContext } from '../contexts/page';
import { store } from '../redux';
import { actions } from '../redux/slices/page';
import { useSectionData } from './use-section-data';
export const useSectionField = (sectionName, blocks) => {
    const { jaenPage } = usePageContext();
    const { data: section, sectionPath } = useSectionData(sectionName);
    const sectionsDict = useMemo(() => {
        const t = blocks.reduce((acc, Section) => ({
            ...acc,
            [Section.options.name]: {
                Component: Section,
                options: Section.options
            }
        }), {});
        return t;
    }, [blocks]);
    const onSectionAdd = useCallback((sectionItemType, between) => {
        store.dispatch(actions.section_add({
            pageId: jaenPage.id,
            sectionItemType,
            path: sectionPath,
            between
        }));
    }, []);
    const onSectionDelete = useCallback((id, ptrPrev, ptrNext) => {
        store.dispatch(actions.section_remove({
            pageId: jaenPage.id,
            sectionId: id,
            path: sectionPath,
            between: [ptrPrev, ptrNext]
        }));
    }, []);
    const onSectionMove = useCallback((id, ptrPrev, ptrNext, ptrNew, direction) => {
        store.dispatch(actions.section_move({
            pageId: jaenPage.id,
            sectionId: id,
            path: sectionPath,
            between: [ptrPrev, ptrNext],
            move: {
                direction,
                ptrNew
            }
        }));
    }, []);
    const onSectionAppend = useCallback((sectionName, id, ptrNext) => {
        onSectionAdd(sectionName, [id, ptrNext || null]);
    }, []);
    const onSectionPrepend = useCallback((sectionName, id, ptrPrev) => {
        onSectionAdd(sectionName, [ptrPrev || null, id]);
    }, []);
    return {
        onSectionAdd,
        onSectionDelete,
        onSectionMove,
        onSectionAppend,
        onSectionPrepend,
        section,
        sectionsDict,
        sectionPath
    };
};
